<template>
  <CRow>
    <CCol col="12" lg="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>
      <CCard>
        <CCardHeader>
          <strong>{{ $lang.recruitments.crud.edit }}</strong>
        </CCardHeader>
        <CForm novalidate @submit.prevent="onSubmit" enctype='multipart/form-data'>
          <CCardBody>
            <CRow>
              <!--              <CCol md="12">-->
              <!--                <h4>Basic Information</h4>-->
              <!--              </CCol>-->
              <CCol md="6">
                <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.recruitments.job_title.$error }"
                >
                  <label class="form__label"
                  >Job Title
                    <required_span/>
                  </label>
                  <input
                      type="text"
                      :placeholder="$lang.recruitments.form.job_title"
                      class="form-control"
                      v-model="recruitments.job_title"
                  />
                  <small
                      class="error"
                      v-if="$v.recruitments.job_title.$error && !$v.recruitments.job_title.required"
                  >{{ $lang.recruitments.validation.required.job_title }}</small
                  >
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Hiring For
                    <required_span/>
                  </label>
                  <v-select
                      :options="hiringOptions"
                      v-model="recruitments.hire_for"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.hire_for.$error && !$v.recruitments.hire_for.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.hire_for }}
                  </small>
                </div>
              </CCol>
              <CCol md="6" v-if="recruitments.hire_for.value == 'Client'">
                <div class="form-group">
                  <label class="form__label">Client<required_span/></label>
                  <input
                      type="text"
                      placeholder="Client"
                      class="form-control"
                      v-model="recruitments.client"
                  />
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Job Type
                    <required_span/>
                  </label>
                  <v-select
                      :options="jobTypeOptions"
                      v-model="recruitments.job_type"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.job_type.$error && !$v.recruitments.job_type.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.job_type }}
                  </small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Employment Type
                    <required_span/>
                  </label>
                  <v-select
                      :options="employmentTypeOptions"
                      v-model="recruitments.employment_type"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.employment_type.$error && !$v.recruitments.employment_type.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.employment_type }}
                  </small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Mode Of Work
                    <required_span/>
                  </label>
                  <v-select
                      :options="workTypeOptions"
                      v-model="recruitments.work_type"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.work_type.$error && !$v.recruitments.work_type.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.work_type }}
                  </small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group">
                  <label class="form__label"
                  >Tentative Joining Date
                    <required_span/>
                  </label>
                  <input type="date" class="form-control" v-model="recruitments.dates"/>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.dates.$error && !$v.recruitments.dates.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.dates }}
                  </small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group">
                  <label class="form__label"
                  >No of Openings
                    <required_span/>
                  </label>
                  <input type="number" class="form-control" v-model="recruitments.no_of_opening"/>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.no_of_opening.$error && !$v.recruitments.no_of_opening.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.no_of_opening }}
                  </small>
                </div>
              </CCol>
              <CCol md="12">
                <div
                    class="form-group"
                    :class="{
                    'form-group--error': $v.recruitments.description.$error,
                  }"
                >
                  <label class="form__label"
                  >Summary
                    <required_span/>
                  </label>
                  <textarea
                      placeholder="Summary"
                      class="form-control"
                      v-model="recruitments.description"
                  />
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.description.$error &&
                      !$v.recruitments.description.required
                    "
                  >{{ $lang.recruitments.validation.required.description }}</small
                  >
                </div>
              </CCol>
              <CCol md="12">
                <hr>
                <h4>Industry & Skill</h4>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Industry
                    <required_span/>
                  </label>
                  <v-select
                      :options="industryOptions"
                      v-model="recruitments.industry"
                      @option:selected="getSubIndustry"
                  >
                  </v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.industry.$error &&
                      !$v.recruitments.industry.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.industry }}
                  </small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Recent Skills
                    <required_span/>
                  </label>
                  <v-select
                      multiple
                      taggable
                      :options="skillsOptions"
                      v-model="recruitments.recent_skills"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.recent_skills.$error && !$v.recruitments.recent_skills.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.recent_skills }}
                  </small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Other Skills
                    <required_span/>
                  </label>
                  <v-select
                      multiple
                      taggable
                      :options="skillsOptions"
                      v-model="recruitments.other_skills"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.other_skills.$error && !$v.recruitments.other_skills.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.other_skills }}
                  </small>
                </div>
              </CCol>
              <CCol md="12">
                <hr>
                <h4>Education</h4>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Education Qualification
                    <required_span/>
                  </label>
                  <v-select
                      multiple
                      taggable
                      :options="educationOptions"
                      v-model="recruitments.education"
                  >
                  </v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.education.$error &&
                      !$v.recruitments.education.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.education }}
                  </small>
                </div>
              </CCol>
              <CCol md="3">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Min Experience
                    <required_span/>
                  </label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="recruitments.experience"
                  />
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.experience.$error && !$v.recruitments.experience.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.experience }}
                  </small>
                </div>
              </CCol>
              <CCol md="3">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Max Experience
                    <required_span/>
                  </label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="recruitments.max_experience"
                  />
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.max_experience.$error && !$v.recruitments.max_experience.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.max_experience }}
                  </small>
                </div>
              </CCol>
              <CCol md="12">
                <hr>
                <h4>Budget</h4>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Currency
                    <required_span/>
                  </label>
                  <v-select
                      :options="currencyOptions"
                      v-model="recruitments.currency"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.currency.$error &&
                      !$v.recruitments.currency.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.currency }}
                  </small>
                </div>
              </CCol>
              <CCol md="3">
                <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.recruitments.budget.$error }"
                >
                  <label class="form__label"
                  >Min CTC / Year
                    <required_span/>
                  </label>
                  <input
                      :placeholder="$lang.recruitments.form.budget"
                      class="form-control"
                      v-model="recruitments.budget"
                  />
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.budget.$error && !$v.recruitments.budget.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.budget }}</small
                  >
                </div>
              </CCol>
              <CCol md="3">
                <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.recruitments.max_budget.$error }"
                >
                  <label class="form__label"
                  >Max CTC / Year
                    <required_span/>
                  </label>
                  <input
                      :placeholder="$lang.recruitments.form.max_budget"
                      class="form-control"
                      v-model="recruitments.max_budget"
                  />
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.max_budget.$error && !$v.recruitments.max_budget.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.max_budget }}</small
                  >
                </div>
              </CCol>
              <CCol md="12">
                <hr>
                <h4>Based On</h4>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <label class="form__label"
                  >Hire Based On
                    <required_span/>
                  </label>
                  <v-select
                      :options="baseOptions"
                      v-model="recruitments.hire_based_on"
                  ></v-select>
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.hire_based_on.$error && !$v.recruitments.hire_based_on.required
                    "
                  >
                    {{ $lang.recruitments.validation.required.hire_based_on }}
                  </small>
                </div>
              </CCol>
              <CCol md="12">
                <hr>
                <h4>Company Detail</h4>
              </CCol>
              <CCol md="6">
                <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.recruitments.owner_name.$error }"
                >
                  <label class="form__label"
                  >Company Name
                    <required_span/>
                  </label>
                  <input
                      type="text"
                      :placeholder="$lang.recruitments.form.owner_name"
                      class="form-control"
                      v-model="recruitments.owner_name"
                  />
                  <small
                      class="error"
                      v-if="$v.recruitments.owner_name.$error && !$v.recruitments.owner_name.required"
                  >{{ $lang.recruitments.validation.required.owner_name }}</small
                  >
                </div>
              </CCol>
              <CCol md="6">
                <div
                    class="form-group"
                >
                  <label class="form__label"
                  >Company Contact Number
                  </label>
                  <input
                      type="number"
                      :placeholder="$lang.recruitments.form.owner_contact"
                      class="form-control"
                      v-model="recruitments.owner_contact"
                  />
                  <!--                  <small-->
                  <!--                      class="error"-->
                  <!--                      v-if="$v.recruitments.owner_contact.$error && !$v.recruitments.owner_contact.required"-->
                  <!--                  >{{ $lang.recruitments.validation.required.owner_contact }}</small-->
                  <!--                  >-->
                </div>
              </CCol>
              <CCol md="6">
                <div
                    class="form-group"
                >
                  <label class="form__label"
                  >Company Email<required_span/>
                  </label>
                  <input
                      type="email"
                      :placeholder="$lang.recruitments.form.owner_email"
                      class="form-control"
                      v-model="recruitments.owner_email"
                  />
                                    <small
                                        class="error"
                                        v-if="$v.recruitments.owner_email.$error && !$v.recruitments.owner_email.required"
                                    >{{ $lang.recruitments.validation.required.owner_email }}</small
                                    >
                </div>
              </CCol>
              <CCol md="6">
                <div
                    class="form-group"
                >
                  <label class="form__label"
                  >Contact Person Name
                  </label>
                  <input
                      type="text"
                      :placeholder="$lang.recruitments.form.contact_name"
                      class="form-control"
                      v-model="recruitments.contact_name"
                  />
                </div>
              </CCol>
              <CCol md="6">
                <div
                    class="form-group"
                >
                  <label class="form__label"
                  >Contact Person Email
                  </label>
                  <input
                      type="email"
                      :placeholder="$lang.recruitments.form.contact_email"
                      class="form-control"
                      v-model="recruitments.contact_email"
                  />
                </div>
              </CCol>
              <CCol md="12">
                <div
                    class="form-group"
                    :class="{
                    'form-group--error': $v.recruitments.description.$error,
                  }"
                >
                  <label class="form__label"
                  >Company Summary
                    <required_span/>
                  </label>
                  <textarea
                      placeholder="Company Summary"
                      class="form-control"
                      v-model="recruitments.company_summary"
                  />
                  <small
                      class="error"
                      v-if="
                      $v.recruitments.company_summary.$error &&
                      !$v.recruitments.company_summary.required
                    "
                  >{{ $lang.recruitments.validation.required.company_summary }}</small
                  >
                </div>
              </CCol>
              <CCol md="3">
                <div class="form-group">
                  <label class="form__label">Logo</label>
                  <input
                      class="form-control"
                      type="file"
                      ref="files"
                      :name="recruitments.companyLogo"
                  />
                </div>
              </CCol>
              <CCol md="3">
                <img width="100px" :src="recruitments.mediadetail" />
              </CCol>
            </CRow>
            <hr>
            <h4>Job Locations</h4>
            <CRow>
              <CCol md="12">
                <table class="table table-bordered">
                  <tr>
                    <th>Country</th>
                    <th>City</th>
                    <th>Action</th>
                  </tr>
                  <tr v-for="(bottom,index) in bottomMenuList">
                    <td>
                      <v-select :id="bottom.id" v-model="bottom.selected"
                                @input="changeCity(index,bottom.selected)"
                                :options="countryOptions"></v-select>
                    </td>
                    <td>
                      <v-select :id="bottom.id" v-model="bottom.city" :options="bottom.cityList"
                                multiple></v-select>
                    </td>
                    <td>
                      <button type="button" class="btn btn-success" @click="addMenu">
                        <i class="fa fa-plus"></i>
                      </button>&nbsp;
                      <button type="button" class="btn btn-danger" @click="subMenu(bottom.id)">
                        <i class="fa fa-minus"></i>
                      </button>
                    </td>
                  </tr>
                </table>
              </CCol>
            </CRow>
            <hr>
            <h4>Attachment</h4>
            <CRow>
              <CCol md="6">
                <input
                    type="file"
                    ref="details"
                    multiple
                    class="form-control"
                    :name="recruitments.uploadFieldName"
                />
              </CCol>
              <CCol md="6">
                <span v-for="(item, index) in recruitments.media">
                  <img width="100px" :src="item.url" /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton
                type="submit"
                size="sm"
                color="primary"
                :disabled="submitted"
            >
              <CIcon name="cil-check-circle"/>
              {{ $lang.buttons.general.crud.submit }}
            </CButton>
            <CButton color="danger" size="sm" @click="cancel">
              <CIcon name="cil-ban"/>
              {{ $lang.buttons.general.crud.cancel }}
            </CButton>
          </CCardFooter>
        </CForm>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {
  projects,
  industry,
  duration,
  currencytype,
  users,
  skills,
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import {required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueToasted from "vue-toasted";
import moment from "moment";

function toast({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "RecruitmentEdit",
  mixins: [Mixin],
  components: {
    required_span
  },
  data() {
    return {
      submitted: false,
      err_msg: "",
      dismissCountDown: 0,
      remoteWorkOptions: [],
      skillsOptions: [],
      industryOptions: [],
      subIndustryOptions: [],
      currencyOptions: [],
      durationOptions: [],
      userOptions: [],
      countryOptions: [],
      getSkills: [],
      cityOptions: [],
      bottomMenuOptions: [],
      experienceOptions: [],
      educationOptions: [],
      bottomMenuList: [{
        id: '0',
        selected: '',
        city: [],
        cityList: []
      }],
      hiringOptions : [
        {
          value: 1,
          label: "Self"
        },
        {
          value: 2,
          label: "Client"
        },
      ],
      jobTypeOptions : [
        {
          value: 3,
          label: "Full-Time"
        },
        {
          value: 4,
          label: "Part-Time"
        },
      ],
      employmentTypeOptions : [
        {
          value: 1,
          label: "Permanent"
        },
        {
          value: 2,
          label: "Contract"
        },
      ],
      workTypeOptions : [
        {
          value: 1,
          label: "Onsite"
        },
        {
          value: 2,
          label: "Remote"
        },
        {
          value: "3",
          label: "Hybrid"
        },
      ],
      baseOptions : [
        {
          value: 1,
          label: "Skill"
        },
        {
          value: 2,
          label: "Experience"
        },
        {
          value: 3,
          label: "Both"
        },
      ],
      self: this,
      module: projects,
      moduleIndustry: industry,
      moduleDuration: duration,
      moduleCurrency: currencytype,
      moduleUser: users,
      moduleSkills: skills,
      recruitments: {
        company_summary : "",
        contact_email : "",
        contact_name : "",
        hire_for : "",
        industry : "",
        job_title : "",
        client : "",
        job_type : "",
        employment_type : "",
        work_type : "",
        dates : "",
        no_of_opening : "",
        description : "",
        recent_skills : [],
        other_skills : [],
        education : [],
        experience : "",
        currency : "",
        budget : "",
        max_budget : "",
        hire_based_on : "",
        owner_name : "",
        owner_contact : "",
        owner_email : "",
        uploadFieldName : [],
        media : [],
        companyLogo : "",
        mediadetail : "",
      },
    };
  },
  validations: {
    recruitments: {
      job_title: {
        required,
      },
      hire_for: {
        required,
      },
      job_type: {
        required,
      },
      employment_type: {
        required,
      },
      work_type: {
        required,
      },
      dates: {
        required,
      },
      no_of_opening: {
        required,
      },
      description: {
        required,
      },
      recent_skills: {
        required,
      },
      other_skills: {
        required,
      },
      education: {
        required,
      },
      experience: {
        required,
      },
      max_experience: {
        required,
      },
      currency: {
        required,
      },
      budget: {
        required,
      },
      max_budget: {
        required,
      },
      hire_based_on: {
        required,
      },
      owner_name: {
        required,
      },
      owner_email: {
        required,
      },
      company_summary: {
        required,
      },
      industry: {
        required,
      },
    },
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    self.remoteWorkOptions.push(
        {value: "Yes", label: "Yes"},
        {value: "No", label: "No"}
    );
    self.dismissCountDown = 0;
    axios.get(this.listUrlApi(this.moduleIndustry)).then((response) => {
      response.data.data.map(function (value, key) {
        if (value.industryId === "") {
          self.industryOptions.push({value: value.id, label: value.industry});
        }
      });
    });
    axios.get(this.listUrlApi(this.moduleDuration)).then((response) => {
      response.data.data.map(function (value, key) {
        self.durationOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get(this.listUrlApi(this.moduleCurrency)).then((response) => {
      response.data.data.map(function (value, key) {
        self.currencyOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get('/countries/lists').then((response) => {
      response.data.data.map(function (value, key) {
        self.countryOptions.push({value: value.id, label: value.name});
      });
    });
    axios.get('/experiences/list').then((response) => {
      response.data.data.map(function (value, key) {
        self.experienceOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get('/educations/list').then((response) => {
      response.data.data.map(function (value, key) {
        self.educationOptions.push({value: value.id, label: value.title});
      });
    });
    const id = this.$route.params.id;
    axios.get('job-opening/view/' + id).then((response) => {
      if (response) {
        let responseData = response.data.data;
        self.recruitments.hire_for =  {value: responseData.hiringForId, label: responseData.hiringFor};
        self.recruitments.industry = {value: responseData.industry.id, label: responseData.industry.title};
        self.recruitments.job_title = responseData.title;
        self.recruitments.client = responseData.clientName;
        self.recruitments.company_summary = responseData.companySummary;
        self.recruitments.contact_email = responseData.companyEmail;
        self.recruitments.contact_name = responseData.contactPerson;
        self.recruitments.job_type = {value: responseData.jobTypeId, label: responseData.jobType};
        self.recruitments.employment_type = {value: responseData.employmentTypeId, label: responseData.employmentType};
        self.recruitments.work_type = {value: responseData.workModeId, label: responseData.workMode};
        self.recruitments.dates = responseData.joiningDate;
        self.recruitments.no_of_opening = responseData.noOfOpenings;
        self.recruitments.description = responseData.description;
        self.recruitments.media = responseData.media;
        self.recruitments.mediadetail = responseData.mediaurl;

        const j = [];
        responseData.skills.map(function (value, key) {
          j.push({value: value.id, label: value.title});
        });
        self.recruitments.recent_skills = j;

        const p = [];
        responseData.otherSkills.map(function (value, key) {
          p.push({value: value.id, label: value.title});
        });
        self.recruitments.other_skills = p;

        const e = [];
        responseData.education.map(function (value, key) {
          e.push({value: value.id, label: value.title});
        });
        self.recruitments.education = e;
        self.recruitments.experience = responseData.minExperience;
        self.recruitments.max_experience = responseData.maxExperience;
        self.recruitments.currency = {value: responseData.currency.id, label: responseData.currency.name};
        self.recruitments.budget = responseData.minSalary;
        self.recruitments.max_budget = responseData.maxSalary;
        self.recruitments.hire_based_on = {value: responseData.baseOnHireId, label: responseData.baseOnHire};
        self.recruitments.owner_name = responseData.companyName;
        self.recruitments.owner_contact = responseData.contactPersonMobileNumber;
        self.recruitments.owner_email = responseData.contactPersonEmail;
        self.bottomMenuList = responseData.bottomMenuList;

        // responseData.cities.map(function (value, key) {
        //   self.bottomMenuList[key].push({value: value.id, label: value.name});
        // });
        // let country = [];
        // responseData.country.map(function (value, key) {
        //   country.push({value: value.id, label: value.name});
        // });

        // self.recruitments.uploadFieldName = responseData.hire_for;
        // self.recruitments.companyLogo = responseData.hire_for;
      }
    });

  },
  methods: {
    changeCity(index, val) {
      let self = this;
      axios.get('/cities/country/list/' + val.value).then((response) => {
        self.bottomMenuList[index].city = [];
        self.bottomMenuList[index].cityList = [];
        response.data.data.map(function (value, key) {
          self.bottomMenuList[index].cityList.push({value: value.id, label: value.name});
        });
      });
    },
    addMenu() {
      this.bottomMenuList.push({
        id: `${++this.menuCounter}`,
        selected: '',
        city: [],
        cityList: [],
      });
    },
    subMenu(id) {
      let self = this;
      const myArr = self.bottomMenuList;
      const index = myArr.findIndex(function (o) {
        return o.id === id;
      });
      if (index !== 0) myArr.splice(index, 1);
    },
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.recruitments.isActive = 1;
      } else {
        self.recruitments.isActive = 0;
      }
    },
    getSubIndustry() {
      let self = this;
      if (self.recruitments.industry.value > 0) {
        // const postData = {industry_id: self.recruitments.industry.value};
        // axios
        //     .post(this.listUrlApi(this.moduleIndustry), postData)
        //     .then((response) => {
        //       self.subIndustryOptions = [];
        //       response.data.data.map(function (value, key) {
        //         if (value.industryId > 0) {
        //           self.subIndustryOptions.push({
        //             value: value.id,
        //             label: value.SubIndustry,
        //           });
        //         }
        //       });
        //     });

        let self = this;
        const postData = {industry_id: self.recruitments.industry.value};
        self.recruitments.recent_skills = [];
        self.recruitments.other_skills = [];
        self.skillsOptions = [];
        axios.post(this.listUrlApi(this.moduleSkills), postData).then((response) => {
          response.data.data.map(function (value, key) {
            self.skillsOptions.push({value: value.id, label: value.title});
          });
        });

      }
    },
    sendAlert() {
      this.$root.$emit("alert", "test1", "test2");
    },
    onSubmit() {
      let self = this;
      this.$v.recruitments.$touch();
      if (this.$v.recruitments.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";
        setTimeout(() => {
          let self = this;
          let selectedDate = "";
          if (self.recruitments.dates !== "") {
            selectedDate = self.recruitments.dates;
          }
          let otherSkill = [];
          self.recruitments.other_skills.map(function (value, key) {
            otherSkill.push(value.label);
          });
          let recentSkill = [];
          self.recruitments.recent_skills.map(function (value, key) {
            recentSkill.push(value.label);
          });
          let edu = [];
          self.recruitments.education.map(function (value, key) {
            edu.push(value.label);
          });
          let edus = [];
          self.bottomMenuList.map(function (value, key) {
            let citys = [];
            value.city.map(function (value, key) {
              citys.push(value.value);
            });
            edus.push({'countryId' : value.selected.value,'cityId' : citys});
          });
          let formData = new FormData();
          formData.append("contactEmail", self.recruitments.contact_email);
          formData.append("contactName", self.recruitments.contact_name);
          formData.append("companySummary", self.recruitments.company_summary);
          formData.append("hiringFor", self.recruitments.hire_for.value);
          formData.append("industry", self.recruitments.industry.value);
          formData.append('jobTitle',self.recruitments.job_title);
          formData.append('clientName',self.recruitments.client);
          formData.append('jobType',self.recruitments.job_type.value);
          formData.append('employmentType',self.recruitments.employment_type.value);
          formData.append('workMode',self.recruitments.work_type.value);
          formData.append('joiningDate',selectedDate);
          formData.append('noOfOpenings',self.recruitments.no_of_opening);
          formData.append('description',self.recruitments.description);
          formData.append('skills',recentSkill.toString());
          formData.append('skillOthers',otherSkill.toString());
          formData.append('educations',edu.toString());
          formData.append('minExperience',self.recruitments.experience);
          formData.append('maxExperience',self.recruitments.max_experience);
          formData.append('currencyId',self.recruitments.currency.value);
          formData.append('minSalary',self.recruitments.budget);
          formData.append('maxSalary',self.recruitments.max_budget);
          formData.append('baseOnHire',self.recruitments.hire_based_on.value);
          let files = self.$refs.details.files;
          for (let i = 0; i < files.length; i++) {
            formData.append('uploadFieldName[]', files[i]);
          }
          formData.append('countryData',JSON.stringify(edus));
          formData.append('contactPerson',self.recruitments.owner_name);
          formData.append('contactPersonMobileNumber',self.recruitments.owner_contact);
          formData.append('contactPersonEmail',self.recruitments.owner_email);
          const fileInput = this.$refs.files;
          if (fileInput && fileInput.files && fileInput.files[0]) {
            formData.append('companyLogo', fileInput.files[0]);
          }
          axios
              .post('/job-opening/update/'+this.$route.params.id, formData)
              .then(function (response) {
                self.submitted = false; //Enable Button
                if (response.data.code === 200) {
                  localStorage.setItem("showAlert", "This is my alert");
                  self.sendAlert();
                  self.$router.push({path: "/job-openings"});
                } else {
                  self.err_msg = response.data.message;
                  self.dismissCountDown = 10;
                }
              })
              .catch(function (error) {
                self.submitted = false; //Enable Button
              });
        }, 500);
      }
    },
    cancel() {
      self.submitted = false; //Enable Button
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/job-openings"});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
